<template>
  <div>
    <app-overlay-loader v-if="preloader" />
    <form
      :class="{ 'loading-opacity': preloader }"
      ref="form"
      data-url="/evaluator/decision/closureFindingsDecision/maintenancePlan/"
    >
      <div class="row" v-if="disableVigilance">
        <div class="col-sm-3">
            <label class="mb-0">Requiere vigilancia 3?</label>
        </div>
        <div class="col-sm">
            <app-input
              type="radio-buttons"
              v-model="inputs.is_vig"
              :list="listVig"
            />
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            <label class="mb-0">
              <p class="text-primary">No. Vigilancia</p></label
            >
          </div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <label class="mb-0"> <p class="text-primary">Fecha</p></label>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            Vigilancia 1
          </div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <app-input
              type="date"
              v-model="inputs.date_v1"
              placeholder="Ingrese Fecha"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="form-group">Vigilancia 2</div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <app-input
              type="date"
              v-model="inputs.date_v2"
              placeholder="Ingrese Fecha"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row" v-if="inputs.is_vig && area === 2">
        <div class="col-sm">
          <div class="form-group">
            Vigilancia 3
          </div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <app-input
              type="date"
              v-model="inputs.date_v3"
              placeholder="Ingrese Fecha"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm">
          <div class="form-group">
            Renovación
          </div>
        </div>

        <div class="col-sm">
          <div class="form-group">
            <app-input
              type="date"
              v-model="inputs.date_renovation"
              placeholder="Ingrese Fecha"
              :required="true"
              :disabled="disabled"
            />
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-primary" @click="submit" v-if="!disabled">
        Guardar
      </button>
    </form>
  </div>
</template>

<script>
import { FormMixin } from "@/core/mixins/form/FormMixin.js";
import * as actions from "../../../../apiURL";

export default {
  mixins: [FormMixin],

  data() {
    return {
      preloader: false,
      inputs: {
        is_vig : 0
      },
      disabled : false,
      disableVigilance: false,
      listVig: [
        {
          id: 0,
          value: "NO",
        },
        {
          id: 1,
          value: "SI",
        },
      ],
    };
  },
  computed: {
    area() {
      return this.$store.state.accreditation.app != null
        ? this.$store.state.accreditation.app.accreditation_area_id
        : null;
    },
  },
  watch: {
    "inputs.date_v1": function() {
      this.inputs.date_v2 = null;
      this.inputs.date_v3 = null;
      this.inputs.date_renovation = null;
      let date_v2 = moment(this.inputs.date_v1).format("YYYY-MM-DD HH:mm");
      let date_v3 = moment(this.inputs.date_v1).format("YYYY-MM-DD HH:mm");
      let date_renovation = moment(this.inputs.date_v1).format(
        "YYYY-MM-DD HH:mm"
      );

      var dt2 = new Date(date_v2);
      dt2.setMonth(dt2.getMonth() + 18);

      if (this.$store.state.accreditation.app.accreditation_area_id === 2 && this.inputs.is_vig) {
        var dt3 = new Date(date_v3);
        dt3.setMonth(dt3.getMonth() + 36);

        var dt4 = new Date(date_renovation);
        dt4.setMonth(dt4.getMonth() + 54);
      } else {
        var dt3 = null;
        var dt4 = new Date(date_renovation);
        dt4.setMonth(dt4.getMonth() + 36);
      }

      this.inputs.date_v2 = dt2;
      this.inputs.date_v3 = dt3;
      this.inputs.date_renovation = dt4;
    },
  },

  created() {
    if (this.$store.state.evaluatorReview.evalTest) {
      this.inputs.id_accApp = this.$store.state.evaluatorReview.evalTestId;
    }
    if(this.$store.state.accreditation.id){
      this.inputs.id_accApp = this.$store.state.accreditation.id;
    }    
    this.info();
  },

  methods: {
    info() {
      if (this.$store.state.evaluatorReview) {
        this.preloader = true;

        this.axiosGet(
          `${actions.DECISION_EVALUATION}/show_vigilances/${this.inputs.id_accApp}`
        )
          .then((response) => {
            
            if(response.data.accApp){
              if(response.data.accApp.status.code == 605){
                this.disabled = false;
              }else{
                this.disabled = true;
              }
            };
            if (response.status == 200 && response.data.otherAcc) {
              if (response.data.otherAcc.length == 0 && response.data.accApp.accreditation_area_id === 2) {
                this.disableVigilance = true;
              } else {
                this.disableVigilance = false;
              }
              
              response.data.otherAcc.forEach(item => {
                let acctype = item.accreditation_type_id;
                switch (acctype) {
                  case 6: //Vigilancia 1
                    let date1 = moment(item.maintenance_date).format(
                      "YYYY-MM-DD HH:mm"
                    );
                    this.inputs.date_v1 = new Date(date1);
                    this.inputs.vigilanceId_1 = item.id;
                    break;
                  case 7: //Vigilancia 2
                    let date2 = moment(item.maintenance_date).format(
                      "YYYY-MM-DD HH:mm"
                    );
                    this.inputs.date_v2 = new Date(date2);
                    this.inputs.vigilanceId_2 = item.id;
                    break;
                  case 8: //Vigilancia 3
                    let date3 = moment(item.maintenance_date).format(
                      "YYYY-MM-DD HH:mm"
                    );
                    this.inputs.is_vig = 1;
                    this.inputs.date_v3 = new Date(date3);
                    this.inputs.vigilanceId_3 = item.id;
                    break;
                  case 9: //Renovacion
                    let date4 = moment(item.maintenance_date).format(
                      "YYYY-MM-DD HH:mm"
                    );
                    this.inputs.date_renovation = new Date(date4);
                    this.inputs.vigilanceId_4 = item.id;
                    break;
                }
              });
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.preloader = false;
          });
      }
    },
    submit() {
      this.save(this.inputs);
    },
    afterSuccess(response) {
      if (this.selectedUrl) {
        this.$toastr.s(this.$t("updated_success"));
      } else {
        this.$toastr.s(this.$t("created_success"));
      }
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterSuccessFromGetEditData(response) {
      this.preloader = false;
    },
    afterFinalResponse() {
      this.preloader = false;
      this.info();
    },
    handleInput() {
      var date_v1 = this.inputs.date_v1;
      this.inputs.date_v2 = null;
      this.inputs.date_renovation = null;
      let date_v2 = moment(this.inputs.date_v1).format("YYYY-MM-DD HH:mm");
      let date_renovation = moment(this.inputs.date_v1).format(
        "YYYY-MM-DD HH:mm"
      );

      var dt2 = new Date(date_v2);
      dt2.setMonth(dt2.getMonth() + 18);



      var dt4 = new Date(date_renovation);
      dt4.setMonth(dt2.getMonth() + 36);

      this.inputs.date_v2 = dt2;
      this.inputs.date_renovation = dt4;
    },
  },
};
</script>
